<a class="menu-list-item" [routerLink]="routerLink">
  <mat-icon class="deco icon">{{icon}}</mat-icon>
  @if (itemtrans) {
    <span class="label" [trans]="itemtrans"></span>
  }
  @if (!itemtrans) {
    <span class="label"><ng-content></ng-content></span>
  }
  <mat-icon class="icon">chevron_right</mat-icon>
</a>
